<div class="select">
    <p class="select__label">{{ label }}</p>
    <div class="select__toggle" (click)="toggleSelect()">
        <p *ngIf="selectedAnswer; else default">{{selectedAnswer}}</p>
        <ng-template #default>
            <p>Please select</p>
        </ng-template>
        <img [ngClass]="{'rotate180': selectActive}" src="assets/icons/icon-select-arrow.svg" alt="">
    </div>
    <div *ngIf="selectActive" class="select__dropdown">
        <ul>
            <li *ngFor="let option of options" [ngClass]="{'active': selectedAnswer === option}" (click)="selectAnswer(option)">{{option}}</li>
        </ul>
    </div>
</div>